import { MonitorSmartphone } from "lucide-react";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { Card, FieldLabel } from "./controls";

const STYLES = [
  { value: "classic", title: "Clásico Azul", desc: "Calculadora: barra azul, teclado 3×4, botón ENTRAR." },
  { value: "dark", title: "Oscuro por Pasos", desc: "Fondo oscuro con pasos numerados y botón IMPRIMIR." },
];

export const PosTab = ({ s, setS, quickAmountsText, setQuickAmountsText }) => (
  <Card icon={MonitorSmartphone} title="Punto de Venta" subtitle="Montos rápidos, loterías y estilo móvil" testId="settings-card-pos">
    <div>
      <FieldLabel title="Montos rápidos del POS (RD$)" hint="Separa con comas. Aparecerán como botones al lado del monto en el POS." />
      <Input value={quickAmountsText} onChange={(e) => setQuickAmountsText(e.target.value)} placeholder="5, 10, 25, 50, 100" className="rounded-sm font-mono h-10" data-testid="settings-quick-amounts" />
      <div className="mt-2 flex flex-wrap gap-1.5">
        {quickAmountsText.split(/[,\s]+/).map((v) => parseFloat(v)).filter(Boolean).map((n, i) => (
          <span key={`${n}-${i}`} className="text-[11px] font-mono font-bold bg-slate-100 border border-slate-200 rounded-sm px-2 py-1">RD${n}</span>
        ))}
      </div>
    </div>
    <div className="flex items-center justify-between gap-3 pt-2 border-t border-slate-100">
      <div>
        <Label className="text-sm font-semibold text-slate-900">Ocultar loterías cerradas en el POS</Label>
        <div className="text-xs text-slate-500">Cuando la hora de cierre ya pasó, la lotería no aparece en el selector. El cajero puede alternar temporalmente desde el POS.</div>
      </div>
      <Switch checked={!!s.pos_hide_closed_games} onCheckedChange={(v) => setS({ ...s, pos_hide_closed_games: v })} data-testid="settings-hide-closed" />
    </div>
    <div className="pt-3 border-t border-slate-100">
      <Label className="text-sm font-semibold text-slate-900">Estilo del POS móvil</Label>
      <div className="text-xs text-slate-500 mb-2">Define cómo se ve el POS en teléfonos. En tablets/PC siempre se usa el modo escritorio.</div>
      <div className="grid grid-cols-2 gap-2">
        {STYLES.map((opt) => {
          const sel = (s.pos_mobile_style || "classic") === opt.value;
          return (
            <button key={opt.value} type="button" onClick={() => setS({ ...s, pos_mobile_style: opt.value })} data-testid={`settings-mobile-style-${opt.value}`}
              className={`text-left rounded-sm border-2 p-3 transition-colors ${sel ? "border-blue-500 bg-blue-50" : "border-slate-200 bg-white hover:border-slate-300"}`}>
              <div className={`text-sm font-black ${sel ? "text-blue-700" : "text-slate-900"}`}>{opt.title}</div>
              <div className="text-[11px] text-slate-500 leading-tight mt-0.5">{opt.desc}</div>
            </button>
          );
        })}
      </div>
    </div>
  </Card>
);
